import React from "react";

const Head = () => {
  return (
    <>
      <section className="head">
        <div className="container flexSB">
          <div className="logo">
            <h1>ZENTRIX</h1>
            <span>ONLINE EDUCATION & LEARNING</span>
          </div>
        </div>
      </section>
    </>
  );
};

export default Head;
